import { LocaleKeys } from '../../../../locale/translation-types'

export enum MaritalStatusEnum {
  SINGLE = 'SINGLE',
  COHABITATION = 'COHABITATION',
  PACS = 'PACS',
  MARRIED = 'MARRIED',
  DIVORCED = 'DIVORCED',
  WIDOW = 'WIDOW'
}

export const maritalStatusEnumMapping: Record<MaritalStatusEnum, LocaleKeys> = {
  [MaritalStatusEnum.SINGLE]: 'marital.status.enum.SINGLE',
  [MaritalStatusEnum.COHABITATION]: 'marital.status.enum.COHABITATION',
  [MaritalStatusEnum.PACS]: 'marital.status.enum.PACS',
  [MaritalStatusEnum.MARRIED]: 'marital.status.enum.MARRIED',
  [MaritalStatusEnum.DIVORCED]: 'marital.status.enum.DIVORCED',
  [MaritalStatusEnum.WIDOW]: 'marital.status.enum.WIDOW'
}
